import React, { useEffect, useState, useRef } from 'react';
import { Section } from './ui/Section';
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);
  return <div className="bg-brand-card border border-neutral-800 rounded-xl overflow-hidden" data-id="element-80">
      <button className="w-full text-left p-6 flex items-center justify-between focus:outline-none" onClick={onToggle} aria-expanded={isOpen} data-id="element-81">
        <span className="font-bold text-lg pr-8" data-id="element-82">{question}</span>
        <span className={`text-brand-accent text-2xl transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-83">
          +
        </span>
      </button>
      <div style={{
      height: `${height}px`
    }} className="overflow-hidden transition-[height] duration-300 ease-in-out" data-id="element-84">
        <div ref={contentRef} data-id="element-85">
          <div className="p-6 pt-0 text-neutral-400 leading-relaxed border-t border-neutral-800/50 mt-2" data-id="element-86">
            {answer}
          </div>
        </div>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si llevo poco tiempo como freelance?',
    a: 'Sí. De hecho, es el mejor momento. Empezar con una estructura sólida, tarifas calculadas y contratos blindados te ahorrará años de errores, clientes tóxicos y dinero perdido.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'El acceso es inmediato. Al completar el pago, recibirás un correo electrónico con el enlace para descargar todos los tomos y bonos en formato PDF de alta calidad, compatibles con cualquier dispositivo.'
  }, {
    q: '¿Funciona si ya tengo clientes pero quiero organizarme mejor?',
    a: 'Absolutamente. El Tomo 3 (Oficina en una Página) y el Tomo 1 (Calculadora) te ayudarán a auditar tus clientes actuales, subirles la tarifa de forma profesional y organizar el caos que ya tienes.'
  }, {
    q: '¿Qué lo diferencia de un curso online de productividad?',
    a: 'Un curso te da teoría que tienes que pensar cómo aplicar. El MegaPack™ te da el sistema ya hecho: plantillas, scripts de copiar y pegar, calculadoras y contratos listos para usar. Es ejecución, no teoría.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, 100% real. Tienes 7 días para probar el sistema. Si no notas una diferencia en tu claridad y organización, nos envías un email y te devolvemos el dinero sin hacer preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section data-id="element-87">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-88">
        ❓ LO QUE MÁS NOS PREGUNTAN
      </h2>
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-89">
        {faqs.map((faq, i) => <AccordionItem key={i} question={faq.q} answer={faq.a} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-90" />)}
      </div>
    </Section>;
}